export default "/images/dailypoints-octoberfest.jpg";